module.exports = __webpack_public_path__ + "images/noInternetConnection_6c1d8ff.svg";